import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from '../actions/actionTypes';
import fetchUserPermissionsSaga from './entitlements';
import {
  fetchEligibleUsersSaga,
  fetchStoriesSaga,
  startReassignmentJobSaga,
  handleJobIdSaga,
  handlePollingJobStatusSaga,
  handleJobRestartSaga
} from './reassign_users';

export function* watchEntitlements() {
  yield takeEvery(actionTypes.FETCH_USER_PERMISSIONS, fetchUserPermissionsSaga);
}

export function* watchReassignUsers() {
  yield takeEvery(actionTypes.FETCH_STORIES, fetchStoriesSaga);
  yield takeEvery(actionTypes.FETCH_ELIGIBLE_USERS, fetchEligibleUsersSaga);
  yield takeEvery(actionTypes.START_REASSIGNMENT_JOB, startReassignmentJobSaga);
  yield takeEvery(actionTypes.HANDLE_JOB_ID, handleJobIdSaga);
  yield takeEvery(actionTypes.HANDLE_POLLING_JOB_STATUS, handlePollingJobStatusSaga);
  yield takeEvery(actionTypes.HANDLE_JOB_RESTART, handleJobRestartSaga);
}



// WEBPACK FOOTER //
// ./app/javascript/app/store/sagas/index.js